/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_AuthInputs */

const en_mobile_upload_error_auth = /** @type {(inputs: Mobile_Upload_Error_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in again and retry the upload.`)
};

const es_mobile_upload_error_auth = /** @type {(inputs: Mobile_Upload_Error_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión de nuevo y vuelve a intentar la subida.`)
};

/**
* | output |
* | --- |
* | "Please sign in again and retry the upload." |
*
* @param {Mobile_Upload_Error_AuthInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_auth = /** @type {((inputs?: Mobile_Upload_Error_AuthInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_AuthInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_auth(inputs)
	return en_mobile_upload_error_auth(inputs)
});